import React, { useState } from "react";
import MediaQuery from "react-responsive";
import { Scrollbar } from "react-scrollbars-custom";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import Iframe from "react-iframe";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Cobaselidik from "./Cobaselidik";
import Lgs1 from "./latihanGs1.png"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#4775d1",
	},
	title: {
		margin: "auto",
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const Ch2 = ({ukuranH,ukuranP}) => {
	const classes = useStyles();
	const [jawaban1, setJawaban1] = useState(false);
	const clickSetJawaban1 = () => setJawaban1(!jawaban1);

	const [openmencobadialog, setOpenmencobadialog] = useState(false);
	const openMencobaDialog = () => {
		setOpenmencobadialog(true);
	};
	const closemencobaDialog = () => {
		setOpenmencobadialog(false);
	};
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);

	const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "50px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "50px", height: "30px" });
	const [form7, setForm7] = useState({ width: "70px", height: "30px" });
	const [form8, setForm8] = useState({ width: "70px", height: "30px" });
	const [form9, setForm9] = useState({ width: "50px", height: "30px" });
	const [form10, setForm10] = useState({ width: "50px", height: "30px" });
	const [form11, setForm11] = useState({ width: "80px", height: "30px" });
	const [form12, setForm12] = useState({ width: "80px", height: "30px" });


	//revisibaru
	const [shownew1, setShownew1] = useState(false);
	const [shownew2, setShownew2] = useState(false);
	const [shownew3, setShownew3] = useState(false);
	const [shownew4, setShownew4] = useState(false);
	const [shownew5, setShownew5] = useState(false);
	const [shownew6, setShownew6] = useState(false);
	const [shownew7, setShownew7] = useState(false);
	const [shownew8, setShownew8] = useState(false);
	const [shownew9, setShownew9] = useState(false);
	const [shownew10, setShownew10] = useState(false);
	const [shownew11, setShownew11] = useState(false);
	const [shownew12, setShownew12] = useState(false);
	const [shownew13, setShownew13] = useState(false);
	const [shownew14, setShownew14] = useState(false);
	const [shownew15, setShownew15] = useState(false);
	const [shownew16, setShownew16] = useState(false);
	const [shownew17, setShownew17] = useState(false);
	const [shownew18, setShownew18] = useState(false);
	const [shownew19, setShownew19] = useState(false);
	const [shownew20, setShownew20] = useState(false);
	const [shownew21, setShownew21] = useState(false);
	const [shownew22, setShownew22] = useState(false);
	const [shownew23, setShownew23] = useState(false);
	const [shownew24, setShownew24] = useState(false);
	const [shownew25, setShownew25] = useState(false);
	// const [shownew26, setShownew26] = useState(false);
	const [shownew27, setShownew27] = useState(false);
	const [shownew28, setShownew28] = useState(false);
	const [shownew29, setShownew29] = useState(false);
	const [shownew30, setShownew30] = useState(false);
	const [shownew31, setShownew31] = useState(false);
	const [shownew32, setShownew32] = useState(false);
	const [formnew1, setFormnew1] = useState({ width: "50px", height: "30px" });
	const [formnew2, setFormnew2] = useState({ width: "50px", height: "30px" });
	const [formnew3, setFormnew3] = useState({ width: "50px", height: "30px" });
	const [formnew4, setFormnew4] = useState({ width: "50px", height: "30px" });
	const [formnew5, setFormnew5] = useState({ width: "50px", height: "30px" });
	const [formnew6, setFormnew6] = useState({ width: "50px", height: "30px" });
	const [formnew7, setFormnew7] = useState({ width: "50px", height: "30px" });
	const [formnew8, setFormnew8] = useState({ width: "50px", height: "30px" });
	const [formnew9, setFormnew9] = useState({ width: "50px", height: "30px" });
	const [formnew10, setFormnew10] = useState({ width: "50px", height: "30px" });
	const [formnew11, setFormnew11] = useState({ width: "50px", height: "30px" });
	const [formnew12, setFormnew12] = useState({ width: "50px", height: "30px" });
	const [formnew13, setFormnew13] = useState({ width: "70px", height: "30px" });
	const [formnew14, setFormnew14] = useState({ width: "50px", height: "30px" });
	const [formnew15, setFormnew15] = useState({ width: "50px", height: "30px" });
	const [formnew16, setFormnew16] = useState({ width: "70px", height: "30px" });
	const [formnew17, setFormnew17] = useState({ width: "50px", height: "30px" });
	const [formnew18, setFormnew18] = useState({ width: "50px", height: "30px" });
	const [formnew19, setFormnew19] = useState({ width: "70px", height: "30px" });
	// const [formnew20, setFormnew20] = useState({ width: "70px", height: "30px" });
	const [formnew21, setFormnew21] = useState({ width: "50px", height: "30px" });
	const [formnew22, setFormnew22] = useState({ width: "50px", height: "30px" });
	const [formnew23, setFormnew23] = useState({ width: "50px", height: "30px" });
	const [formnew24, setFormnew24] = useState({ width: "75px", height: "30px" });
	const [formnew25, setFormnew25] = useState({ width: "75px", height: "30px" });
	const [formnew26, setFormnew26] = useState({ width: "75px", height: "30px" });
	const handlenew1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setFormnew1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew7(true)
		} else if (jwb === "") {
			setFormnew1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1") {
			setFormnew2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew8(true)
		} else if (jwb === "") {
			setFormnew2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "9") {
			setFormnew3({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew9(true)
		} else if (jwb === "") {
			setFormnew3({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew3({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1") {
			setFormnew4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew10(true)
		} else if (jwb === "") {
			setFormnew4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setFormnew5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew11(true)
		} else if (jwb === "") {
			setFormnew5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "12") {
			setFormnew6({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew12(true)
		} else if (jwb === "") {
			setFormnew6({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew6({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4.5") {
			setFormnew7({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew13(true)
		} else if (jwb === "") {
			setFormnew7({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew7({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setFormnew8({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew14(true)
		} else if (jwb === "") {
			setFormnew8({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew8({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4.5,0") {
			setFormnew9({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShownew15(true)
		} else if (jwb === "") {
			setFormnew9({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setFormnew9({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handlenew10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setFormnew10({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew16(true)
		} else if (jwb === "") {
			setFormnew10({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew10({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "9") {
			setFormnew11({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew17(true)
		} else if (jwb === "") {
			setFormnew11({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew11({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,9") {
			setFormnew12({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShownew18(true)
		} else if (jwb === "") {
			setFormnew12({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setFormnew12({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handlenew13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb==="0") {
			setFormnew13({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShownew19(true)
		} else if (jwb === "") {
			setFormnew13({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setFormnew13({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handlenew14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "12") {
			setFormnew14({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew20(true)
		} else if (jwb === "") {
			setFormnew14({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew14({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew15 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setFormnew15({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew21(true)
		} else if (jwb === "") {
			setFormnew15({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew15({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew16 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "12,0") {
			setFormnew16({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShownew22(true)
		} else if (jwb === "") {
			setFormnew16({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setFormnew16({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handlenew17 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setFormnew17({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew23(true)
		} else if (jwb === "") {
			setFormnew17({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew17({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew18 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setFormnew18({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew24(true)
		} else if (jwb === "") {
			setFormnew18({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew18({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew19 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,4") {
			setFormnew19({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShownew25(true)
		} else if (jwb === "") {
			setFormnew19({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setFormnew19({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};

	const handlenew21 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "E") {
			setFormnew21({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew27(true)
		} else if (jwb === "") {
			setFormnew21({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew21({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew22 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setFormnew22({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew28(true)
		} else if (jwb === "") {
			setFormnew22({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew22({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew23 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setFormnew23({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew29(true)
		} else if (jwb === "") {
			setFormnew23({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setFormnew23({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew24 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "150000") {
			setFormnew24({
				border: "6px solid #1aff66",
				width: "80px",
				height: "30px",
			})
			setShownew30(true)
		} else if (jwb === "") {
			setFormnew24({
				border: "6px solid yellow",
				width: "80px",
				height: "30px",
			});
		} else {
			setFormnew24({
				border: "6px solid red",
				width: "80px",
				height: "30px",
			});
		}
	};
	const handlenew25 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "120000") {
			setFormnew25({
				border: "6px solid #1aff66",
				width: "80px",
				height: "30px",
			})
			setShownew31(true)
		} else if (jwb === "") {
			setFormnew25({
				border: "6px solid yellow",
				width: "80px",
				height: "30px",
			});
		} else {
			setFormnew25({
				border: "6px solid red",
				width: "80px",
				height: "30px",
			});
		}
	};
	const handlenew26 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "90000") {
			setFormnew26({
				border: "6px solid #1aff66",
				width: "75px",
				height: "30px",
			})
			setShownew32(true)
		} else if (jwb === "") {
			setFormnew26({
				border: "6px solid yellow",
				width: "75px",
				height: "30px",
			});
		} else {
			setFormnew26({
				border: "6px solid red",
				width: "75px",
				height: "30px",
			});
		}
	};
	//batasrevisibaru

	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "20") {
			setForm1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew1(true)
		} else if (jwb === "") {
			setForm1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "10") {
			setForm2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew2(true)
		} else if (jwb === "") {
			setForm2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "90") {
			setForm3({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew3(true)
		} else if (jwb === "") {
			setForm3({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm3({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "10") {
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew4(true)
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "30") {
			setForm5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew5(true)
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "120") {
			setForm6({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShownew6(true)
		} else if (jwb === "") {
			setForm6({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm6({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "20000") {
			setShow1(true);
			setForm7({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm7({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm7({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "30000") {
			setShow2(true);
			setForm8({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm8({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm8({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow3(true);
			setForm9({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm9({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm9({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow4(true);
			setForm10({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm10({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm10({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "20000") {
			setShow5(true);
			setForm11({
				border: "6px solid #1aff66",
				width: "80px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm11({
				border: "6px solid yellow",
				width: "80px",
				height: "30px",
			});
		} else {
			setForm11({
				border: "6px solid red",
				width: "80px",
				height: "30px",
			});
		}
	};
	const handleform12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "30000") {
			setShow6(true);
			setForm12({
				border: "6px solid #1aff66",
				width: "80px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm12({
				border: "6px solid yellow",
				width: "80px",
				height: "30px",
			});
		} else {
			setForm12({
				border: "6px solid red",
				width: "80px",
				height: "30px",
			});
		}
	};

	return (
		<div
			className="mt-2"
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
			}}
		>
			<div
				style={{
					width: "80%",
					margin: "auto",
				}}
			>
				<p
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						fontSize: `${ukuranP}px`
					}}
				>
					Seorang petani ingin memberikan pupuk pada tanaman padinya. Pupuk yang
					diberikan harus mengandung sebanyak-banyaknya 90 g campuran a dan 120 g
					campuran b. Pupuk I mengandung 20 g campuran a dan 10 g campuran b per
					bungkus. Pupuk II mengandung 10 g campuran a dan 30 g campuran b per
					bungkus. Petani itu ingin mencampur kedua pupuk tersebut. Satu bungkus
					pupuk I harganya Rp20.000,00 dan pupuk II harganya Rp30.000 per
					bungkus. Tentukan biaya maksimum yang harus dikeluarkan oleh petani
					tersebut.
				</p>
			</div>
			<div
				style={{
					color: "green",
					display: "flex",
					justifyContent: "space-between",
					width: "10%",
					marginLeft: "20px",
				}}
			>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.3s alternate ease infinite",
					}}
				>
					<SkipNextIcon />
				</div>
				<p
					style={{ marginLeft: "22px", cursor: "pointer" }}
					onClick={clickSetJawaban1}
				>
					<strong>
						<u>Jawaban</u>
					</strong>
				</p>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.2s alternate ease infinite",
					}}
				>
					<SkipPreviousIcon />
				</div>
			</div>
			{jawaban1 ? (
				<div style={{ margin: "auto", width: "82%", lineHeight: "35px" }}>
					<ol style={{fontSize:`${ukuranP}px`}}>
						<li>Pertama diperolah tabel sebagai berikut : </li>
						<MediaQuery minWidth={476} maxWidth={1824}>
							<table className="table">
								<thead>
									<tr>
										<th scope="col">Pembatas</th>
										<th scope="col">Pupuk 1</th>
										<th scope="col">Pupuk 2</th>
										<th scope="col">Ketersediaan</th>
										<th scope="col">Satuan</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Campuran A</td>
										<td>
											<input type="text" onChange={handleform1} style={form1} />
										</td>
										<td>
											<input type="text" onChange={handleform2} style={form2} />
										</td>
										<td>
											<input type="text" onChange={handleform3} style={form3} />
										</td>
										<td>Gram</td>
									</tr>
									<tr>
										<td>Campuran B</td>
										<td>
											<input type="text" onChange={handleform4} style={form4} />
										</td>
										<td>
											<input type="text" onChange={handleform5} style={form5} />
										</td>
										<td>
											<input type="text" onChange={handleform6} style={form6} />
										</td>
										<td>Gram</td>
									</tr>
									<tr>
										<td>Harga</td>
										<td>
											<input type="text" onChange={handleform7} style={form7} />
										</td>
										<td>
											<input type="text" onChange={handleform8} style={form8} />
										</td>
										<td>-</td>
										<td>Rupiah</td>
									</tr>
								</tbody>
							</table>
						</MediaQuery>
						<MediaQuery maxWidth={475}>
							<Scrollbar style={{ width: 180, height: 200 }}>
								<table className="table">
									<thead>
										<tr>
											<th scope="col">Pembatas</th>
											<th scope="col">Pupuk 1</th>
											<th scope="col">Pupuk 2</th>
											<th scope="col">Ketersediaan</th>
											<th scope="col">Satuan</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Campuran A</td>
											<td>
												<input
													type="text"
													onChange={handleform1}
													style={form1}
												/>
											</td>
											<td>
												<input
													type="text"
													onChange={handleform2}
													style={form2}
												/>
											</td>
											<td>
												<input
													type="text"
													onChange={handleform3}
													style={form3}
												/>
											</td>
											<td>Gram</td>
										</tr>
										<tr>
											<td>Campuran B</td>
											<td>
												<input
													type="text"
													onChange={handleform4}
													style={form4}
												/>
											</td>
											<td>
												<input
													type="text"
													onChange={handleform5}
													style={form5}
												/>
											</td>
											<td>
												<input
													type="text"
													onChange={handleform6}
													style={form6}
												/>
											</td>
											<td>Gram</td>
										</tr>
										<tr>
											<td>Harga</td>
											<td>
												<input
													type="text"
													onChange={handleform7}
													style={form7}
												/>
											</td>
											<td>
												<input
													type="text"
													onChange={handleform8}
													style={form8}
												/>
											</td>
											<td>-</td>
											<td>Rupiah</td>
										</tr>
									</tbody>
								</table>
							</Scrollbar>
						</MediaQuery>
						{show1 && show2 &&shownew1&&shownew2&&shownew3&&shownew4&&shownew5&&shownew6 ? (
							<div>
								<li>
									Pilih bahwa x adalah banyaknya pupuk 1, sedangkan y adalah banyaknya Pupuk 2.
								</li>
								<li>Kita buat dalam bentuk pertidaksamaan seperti berikut :</li>
								
									<ul>
										<li>Pertama pada Campuran A</li>
										<li>
										<InlineMath math="20x + 10y ≤ 90 " /> &nbsp; Agar
										memudahkan kita, coba kalian sederhanakan dengan membagi semua koefisien dan
										konstanta dengan 10
										</li>
										<p className="text-center alert alert-warning">
												Coba kamu isi form di bawah ini!
											</p>
										<li>
										<input type="text" style={formnew1} onChange={handlenew1} />{" "}
												<InlineMath math="x + " /> &nbsp;
												<input type="text" style={formnew2} onChange={handlenew2} />
												<InlineMath math="y ≤ " />
												&nbsp;
												<input
													type="text"
													style={formnew3}
													onChange={handlenew3}
												/>{" "}										
										</li>
										</ul>
										
					{shownew7&&shownew8&&shownew9?
					<>
							<ul>
										<li>Kedua pada Campuran B</li>
										<li>
										<InlineMath math="10x + 30y ≤ 120 " /> &nbsp; Agar
										memudahkan kita, coba kalian sederhanakan dengan membagi semua koefisien dan
										konstanta dengan 10
										</li>
										<p className="text-center alert alert-warning">
												Coba kamu isi form di bawah ini!
											</p>
										<li>
										<input type="text" style={formnew4} onChange={handlenew4} />{" "}
												<InlineMath math="x + " /> &nbsp;
												<input type="text" style={formnew5} onChange={handlenew5} />
												<InlineMath math="y ≤ " />
												&nbsp;
												<input
													type="text"
													style={formnew6}
													onChange={handlenew6}
												/>{" "}										
										</li>
										</ul>
						{shownew10&&shownew11&&shownew12?
						<>
<li>
	{" "}
	Karena tidak mungkin banyaknya pupuk 1 dan pupuk 2 itu negatif, maka x ≥{" "}
	<input type="text" onChange={handleform9} style={form9} />
	dan y ≥{" "}
	<input type="text" onChange={handleform10} style={form10} />.
</li>
{show3 && show4 ? (
	<div>
		<li>
			{" "}
			Sehingga kita mendapatkan fungsi kendala adalah{" "}
			<InlineMath math="2x+y ≤ 9;" />{" "}
			<InlineMath math="x+3y ≤ 12;" />{" "}
			<InlineMath math="x ≥ 0" />, dan{" "}
			<InlineMath math="y ≥ 0" />. Sedangkan untuk fungsi
			objektif adalah <InlineMath math="z = " />{" "}
			<input
				type="text"
				onChange={handleform11}
				style={form11}
			/>
			<InlineMath math="x + " />
			<input
				type="text"
				onChange={handleform12}
				style={form12}
			/>{" "}
			<InlineMath math=" y" />.
		</li>
		{show5 && show6 ? (
			<div>
	<li>
	Selanjutnya kita mencari titik potong
																		pada sumbu <InlineMath math="\space x " /> dan pada sumbu <InlineMath math="\space y " />&nbsp; yang ada pada
																		<InlineMath math="\space 2x + y = 9" />
																		&nbsp; dan tabelnya di bawah ini
														
													</li>
	<p className="text-center alert alert-warning h6">Jika nilai desimal gunakan "titik(.)"</p>
													<p>
														<MediaQuery minWidth={476} maxWidth={1824}>
															<table
																style={{ width: "100%", textAlign: "center" }}
																className="table"
															>
																<tr>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		x
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		y
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		(x,y)
																	</th>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew7}
																			style={formnew7}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew8}
																			style={formnew8}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew9}
																			style={formnew9}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew10}
																			style={formnew10}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew11}
																			style={formnew11}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew12}
																			style={formnew12}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
															</table>
														</MediaQuery>
														<MediaQuery maxWidth={475}>
														<table
																style={{ width: "100%", textAlign: "center" }}
																className="table"
															>
																<tr>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		x
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		y
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		(x,y)
																	</th>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew7}
																			style={formnew7}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew8}
																			style={formnew8}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew9}
																			style={formnew9}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew10}
																			style={formnew10}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew11}
																			style={formnew11}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew12}
																			style={formnew12}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
															</table>
														</MediaQuery>
													</p>
	{shownew13&&shownew14&&shownew15&&shownew16&&shownew17&&shownew18?
	<>
	<li>
	Selanjutnya kita mencari titik potong
																		pada sumbu <InlineMath math="\space x " /> dan pada sumbu <InlineMath math="\space y " />&nbsp; yang ada pada
																		<InlineMath math="\space x + 3y = 12" />
																		&nbsp; dan tabelnya di bawah ini
	
	</li>
													<p>
														<MediaQuery minWidth={476} maxWidth={1824}>
															<table
																style={{ width: "100%", textAlign: "center" }}
																className="table"
															>
																<tr>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		x
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		y
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		(x,y)
																	</th>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew14}
																			style={formnew14}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew15}
																			style={formnew15}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew16}
																			style={formnew16}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew17}
																			style={formnew17}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew18}
																			style={formnew18}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew19}
																			style={formnew19}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
															</table>
														</MediaQuery>
														<MediaQuery maxWidth={475}>
														<table
																style={{ width: "100%", textAlign: "center" }}
																className="table"
															>
																<tr>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		x
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		y
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		(x,y)
																	</th>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew14}
																			style={formnew14}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew15}
																			style={formnew15}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew16}
																			style={formnew16}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew17}
																			style={formnew17}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew18}
																			style={formnew18}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handlenew19}
																			style={formnew19}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
															</table>
														</MediaQuery>
													</p>
{shownew20&&shownew21&&shownew22&&shownew23&&shownew24&&shownew25?
<>
<li>Coba kamu kerjakan apa yang diperintahkan pada grafik di bawah!</li>
<div className="alert alert-warning"><b className="text-center">Petunjuk :</b> 
<ol>
<li>Kalian dapat melakukan zoom pada grafik seperti biasa</li>	
<li>Slider dapat kamu geser untuk mendapatkan nilai optimunya</li>	
</ol></div>

<MediaQuery minWidth={476} maxWidth={1824}>
<Iframe scrolling="no" title="Rev" src="https://www.geogebra.org/material/iframe/id/gv5axbvk/width/850/height/700/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="850px" height="700px" allowFullScreen/>
</MediaQuery>
<MediaQuery maxWidth={475}>
<Iframe scrolling="no" title="Rev" src="https://www.geogebra.org/material/iframe/id/gv5axbvk/width/850/height/700/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="180px"
						height="200px" allowFullScreen />	
</MediaQuery>
<li>Maka titik koordinat yang memiliki nilai maksimum adalah titik 
	<input type="text" onChange={handlenew21}
	style={formnew21}
	/> </li>
{shownew27?
<>
<li>Coba kita tentukan nilai dari titik koordinat E dengan menggunakan eliminasi</li>
<div className="d-flex justify-content-center">
<MediaQuery minWidth={476} maxWidth={1824}>
<TransformWrapper defaultScale={1}>
<TransformComponent><img src={Lgs1} alt="img1" /></TransformComponent>
</TransformWrapper>
</MediaQuery>
</div>
<MediaQuery maxWidth={475}>
<TransformWrapper defaultScale={1}>
<TransformComponent><img src={Lgs1} alt="img1" /></TransformComponent>
</TransformWrapper>
</MediaQuery>
<li>Maka nilai <InlineMath math=" y ="/><input type="text" style={formnew22} onChange={handlenew22} /></li>
{shownew28?
<>
<li> Kita akan mencari nilai <InlineMath math=" x " /> dengan mensubstitusikan nilai <InlineMath math=" y " /></li>
<li>
																																Selanjutnya
																																substitusikan&nbsp;
																																<InlineMath math=" y = 3" />&nbsp;
																																ke salah satu
																																persamaan.
																																Disini kita
																																memakai&nbsp;
																																<InlineMath math="2x + y = 9" />
																															</li>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="2x + 3 = 9" />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math=" 2x + 3 = 9" />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="2x = 9 - 3 " />
																															</div>
																															<div>
																																<InlineMath math="\iff" />
																																&nbsp;&nbsp;
																																<InlineMath math="2x = 6 " />
																															</div>
<p>Maka nilai <InlineMath math="x = "/><input type="text" style={formnew23} onChange={handlenew23}/></p>
{shownew29?
<>
Dari gambar daerah
																																penyelesaian di
																																atas maka
																																didapatkan
																																titik-titik
																																koordinat sebagai
																																berikut (0,0), A(4,5 ,0),
																																D(0,4), dan E(3,
																																3 ) Untuk
																																menentukan nilai
																																maksimumnya,
																																substitusikan
																																setiap titik
																																koordinat ke dalam
																																fungsi objektif
																																yaitu{" "}
<div className="d-flex justify-content-center">
					<table
																																			className="table"
																																			style={{
																																				border:
																																					"2px solid green",
																																				borderCollapse:
																																					"collapse",
																																				width:
																																					"100%",
																																				textAlign:
																																					"center",
																																			}}
																																		>
																																			<tr>
																																				<th
																																					scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}
																																				>
																																					Titik
																																					koordinat
																																				</th>
																																				<th scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math="z = 20000x + 30000y" />
																																				</th>
																																				<th scope="col"
																																					style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					Hasil
																																				</th>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					
																																					(0,0)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 20000(0) + 30000(0)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<input type="text" style={formnew13} onChange={handlenew13}/>
																																				</td>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					A
																																					(4.5,0)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 20000(4.5) + 30000(0)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<input type="text" style={formnew26} onChange={handlenew26}/>
																																				</td>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					D
																																					(0,4)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 20000(0) + 30000(4)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<input type="text" style={formnew25} onChange={handlenew25}/>
																																				</td>
																																			</tr>
																																			<tr>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					E (3
																																					, 3)
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																					<InlineMath math=" 20000(3) + 30000(3)" />
																																				</td>
																																				<td style={{
																																						border:
																																							"2px solid green",
																																					}}>
																																				<input type="text" style={formnew24} onChange={handlenew24}/>
																																				</td>
																																			</tr>
																																
					</table>
					</div>
{shownew30&&shownew31&&shownew32&&shownew19?
<>
<p className="text-center h6 mt-2 mb-2">
							Jadi, biaya <b>maksimum</b> yang dibutuhkan oleh
							petani tersebut adalah{" "}
							<InlineMath math=" Rp150.000,00 " /> dengan cara
							membeli 3 bungkus pupuk 1 dan 3 bungkus pupuk 2.
						</p>

<p className="text-center alert alert-success h6">Coba kamu kerjakan Mari Mencoba di bawah agar menambah pemahaman kamu dalam mencari nilai optimum dengan menggunakan metode garis selidik!</p>
						<div className="d-flex justify-content-center">
							<button
								className="btn btn-outline-primary mt-3 mb-2"
								onClick={openMencobaDialog}
							>
								Mari Mencoba
							</button>
						</div>
</>
:null}
</>
:null}
</>
:null}
</>
:null}

</>
:null}

	</>
	:null}

			</div>
		) : null}
	</div>
) : null}
						</>
						:null}
					</>
					:null}
								
							</div>
						) : null}
					</ol>
				</div>
			) : null}
			<Dialog
				fullScreen
				open={openmencobadialog}
				onClose={closemencobaDialog}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							onClick={closemencobaDialog}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						<h4 className={classes.title}>
							Mari Mencoba Nilai Optimum Garis Selidik
						</h4>
					</Toolbar>
				</AppBar>
				<Cobaselidik />
			</Dialog>
		</div>
	);
};

export default Ch2;
